import axios from 'axios';

const API = axios.create({
  baseURL: '/api',
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      sessionStorage.setItem('session_expired', '1');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const login = (username, password) => {
  const form = new URLSearchParams();
  form.append('username', username);
  form.append('password', password);
  return API.post('/auth/login', form, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

export const getUsers = () => API.get('/users');
export const createUserAPI = (data) => API.post('/users', data);
export const updateUserAPI = (username, data) => API.put(`/users/${username}`, data);
export const deleteUserAPI = (username) => API.delete(`/users/${username}`);
export const getMyModules = () => API.get('/users/me/modules');
export const setUserModulesAPI = (username, modules) => API.put(`/users/${username}/modules`, { modules });

export const getVessels = () => API.get('/vessels');
export const getVessel = (imo) => API.get(`/vessels/${imo}`);
export const createVessel = (data) => API.post('/vessels', data);
export const updateVessel = (imo, data) => API.put(`/vessels/${imo}`, data);
export const deleteVessel = (imo) => API.delete(`/vessels/${imo}`);
export const importVessels = (formData, overwrite = true) =>
  API.post(`/vessels/import?overwrite=${overwrite}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const logoutAPI = () => API.post('/auth/logout');
export const getLoginLogs = (limit = 200) => API.get(`/admin/login-logs?limit=${limit}`);

// Report Tracker
export const getReportTypes = () => API.get('/report-tracker/types');
export const createReportType = (data) => API.post('/report-tracker/types', data);
export const updateReportType = (id, data) => API.put(`/report-tracker/types/${id}`, data);
export const deleteReportType = (id) => API.delete(`/report-tracker/types/${id}`);

export const getReports = (typeId) => API.get(`/report-tracker/reports?report_type_id=${typeId}`);
export const createReport = (data) => API.post('/report-tracker/reports', data);
export const updateReport = (id, data) => API.put(`/report-tracker/reports/${id}`, data);
export const deleteReport = (id) => API.delete(`/report-tracker/reports/${id}`);

export const getTrackerSettings = () => API.get('/report-tracker/settings');
export const updateTrackerSettings = (data) => API.put('/report-tracker/settings', data);
export const testTrackerMail = () => API.post('/report-tracker/test-mail');

export const getTrackerDashboard = () => API.get('/report-tracker/dashboard');

export default API;
